window.Hotkeys = function () {
    var el = this;
    var KEY_V = 86;
    var KEY_C = 67;
    var KEY_ESCAPE = 27;
    var KEY_DELETE = 46;
    var KEY_UP = 38;
    var KEY_DOWN = 40;
    var KEY_LEFT = 37;
    var KEY_RIGHT = 39;

    function dispatcher(event) {
        switch(event.keyCode) {
            case KEY_DELETE:
                removeDispatcher(event);
                break;
            case KEY_ESCAPE:
                escapeDispatcher(event);
                break;
            case KEY_C:
                copyDispatcher(event);
                break;
            case KEY_V:
                pasteDispatcher(event);
                break;
            case KEY_UP:
            case KEY_DOWN:
            case KEY_LEFT:
            case KEY_RIGHT:
                moveDispatcher(event);
                break;
        }
    }
    
    function removeDispatcher(event) {
        var selection = document.getElementsByClassName('selection');
        if (selection.length > 0) {
            switch (el.selectType) {
                case 'cell':
                    event.preventDefault();
                    el.cell.remove();
                    break;
                case 'backgrounds':
                    event.preventDefault();
                    el.image.remove();
                    break;
                case 'decors':
                    event.preventDefault();
                    el.decors.remove();
                    break;
                case 'text':
                    event.preventDefault();
                    el.text.remove();
                break;
            }
        }
    }
    
    function escapeDispatcher(event) {
        event.preventDefault();
        var selection = document.getElementsByClassName('selection');
        if (selection) {
            el.selection.hide();
        }
    }
    
    function copyDispatcher(event) {
        if (!event.ctrlKey) {
            return true;
        }
        
        var selection = document.getElementsByClassName('selection');
        if (!selection) {
            return true;
        }
        
        switch (el.selectType) {
            case 'cell':
                el.cell.copy();
                break;
            case 'decors':
                el.decors.copy();
                break;
            case 'text':
                el.text.copy();
                break;
            case 'calendar_grids':
                el.calendarGrid.copy();
                break;
        }
    };
    
    function pasteDispatcher(event) {
        if (!event.ctrlKey) {
            return true;
        }
        
        var selection = document.getElementsByClassName('selection');
        if (!selection) {
            return true;
        }
        
        switch (el.selectType) {
            case 'cell':
                el.cell.paste();
                break;
            case 'decors':
                el.decors.paste();
                break;
            case 'text':
                el.text.paste();
                break;
            case 'calendar_grids':
                el.calendarGrid.paste();
                break;
        }
    };

    function moveDispatcher(event) {
        var selection = document.getElementsByClassName('selection');
        if (selection.length === 0) {
            return true;
        }

        var keyMovement = {
            X : 0,
            Y : 0,
        }; 

        switch (event.keyCode) {
            case KEY_UP:
                keyMovement.Y = -1;
                keyMovement.X = 0;
                break;
            case KEY_DOWN:
                keyMovement.Y = 1;
                keyMovement.X = 0;
                break;
            case KEY_RIGHT:
                keyMovement.X = 1;
                keyMovement.Y = 0;
                break;
            case KEY_LEFT:
                keyMovement.X = -1;
                keyMovement.Y = 0;
                break;
        }

        switch (el.selectType) {
            case 'cell':
                el.cell.beginMove();
                el.cell.move(null, keyMovement);
                el.cell.endMove();
                break;
            case 'decors':
                el.decors.beginMove();
                el.decors.keyMovement(keyMovement);
                el.decors.endMove();
                break;
            case 'text':
                el.text.beginMove();
                el.text.keyMovement(keyMovement);
                el.text.endMove();
                break;
        }
        
    }
    
    $(document).on('keydown', dispatcher);

    //cancel scroll page
    window.addEventListener("keydown", function(e) {
        var selection = document.getElementsByClassName('selection');
        if (selection.length === 0) {
            return true;
        }
        if(["ArrowUp","ArrowDown","ArrowLeft","ArrowRight"].indexOf(e.code) > -1) {
            e.preventDefault();
        }
    }, false);
};